// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__wLirW","nav_item":"header_nav_item__zSNnD"};